import {
    CREATE_USER_GROUP_REQUEST,
    CREATE_USER_GROUP_SUCCESS,
    CREATE_USER_GROUP_FAILURE,
    GET_USERS_GROUPS_REQUEST,
    GET_USERS_GROUPS_SUCCESS,
    GET_USERS_GROUPS_FAILURE,
    GET_USER_GROUP_REQUEST,
    GET_USER_GROUP_SUCCESS,
    GET_USER_GROUP_FAILURE,
    CLEAN_USERS_GROUPS,
    CLEAN_USER_GROUP,
    SET_TOTAL_USERS_GROUPS,
    DELETE_USER_GROUP_REQUEST,
    DELETE_USER_GROUP_SUCCESS,
    DELETE_USER_GROUP_FAILURE,
    UPDATE_USER_GROUP_REQUEST,
    UPDATE_USER_GROUP_SUCCESS,
    UPDATE_USER_GROUP_FAILURE,
    SEARCH_MEMBERS_REQUEST,
    SEARCH_MEMBERS_SUCCESS,
    SEARCH_MEMBERS_FAILURE,
    SET_TOTAL_MEMBER_SUGGESTIONS,
    ADD_MEMBER,
    DELETE_MEMBER,
    DELETE_ALL_MEMBERS,
    GROUP_GENERAL_INFORMATION_READY,
    GROUP_EXPRESS_CONFIGURATION_READY,
    GROUP_USERS_CONFIGURATION_READY,
    GET_MUSIC_ON_HOLD_REQUEST,
    GET_MUSIC_ON_HOLD_SUCCESS,
    GET_MUSIC_ON_HOLD_FAILURE,
    SET_MEMBERS,
    SEARCH_DEFAULT_EXTENSION_REQUEST,
    SEARCH_DEFAULT_EXTENSION_SUCCESS,
    SEARCH_DEFAULT_EXTENSION_FAILURE,
    SET_TOTAL_DEFAULT_EXTENSION,
    SET_DEFAULT_EXTENSION
} from '../actions/groupsActionTypes';
import map from 'lodash/map';
import find from 'lodash/find';
import reject from 'lodash/reject';

const initialState = {
    groups: [],
    isFetching: false,
    error: false,
    totalGroups: 0,
    searchText: '',
    isCreating: false,
    creationError: false,
    edition: {
        group: null,
        isEditing: false,
        error: false,
        fetching: false
    },
    memberSuggestions: [],
    suggestionSearchText: '',
    isFetchingMemberSuggestions: false,
    totalMemberSuggestions: 0,
    suggestionsError: false,
    members: [],
    groupGeneralInformationReady: false,
    groupGeneralInformation: null,
    groupExpressConfigurationReady: false,
    groupExpressConfiguration: {
        Extension: '',
        Strategy: '1',
        Recording: '0',
        RecordingCapacity: '',
        MusicOnHold: 'none',
        RingTime: '30'
    },
    groupUsersConfigurationReady: false,
    groupUsersConfiguration: null,
    musicOnHold: {
        moh: null,
        fetching: false,
        error: false
    },
    defaultExtensionSuggestions: [],
    defaultExtensionSearchText: '',
    isFetchingDefaultExtensionSuggestions: false,
    totalDefaultExtensionSuggestions: 0
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_USERS_GROUPS_REQUEST: {
            return {
                ...state,
                isFetching: true,
                searchText: action.payload.searchText
            };
        }
        case GET_USERS_GROUPS_SUCCESS: {
            return {
                ...state,
                isFetching: false,
                groups: [...state.groups, ...action.payload.usersGroups],
                error: false
            };
        }
        case GET_USERS_GROUPS_FAILURE: {
            return {
                ...state,
                isFetching: false,
                error: true,
                searchText: ''
            };
        }
        case CLEAN_USERS_GROUPS: {
            return {
                ...state,
                groups: [],
                totalGroups: 0
            };
        }
        case SET_TOTAL_USERS_GROUPS: {
            return {
                ...state,
                totalGroups: action.payload.total
            };
        }
        case DELETE_USER_GROUP_REQUEST: {
            const usersGroupsList = map([...state.groups], group => group.GroupId === action.payload.id
                ? { ...group, removing: true }
                : group
            );

            return {
                ...state,
                groups: usersGroupsList
            };
        }
        case DELETE_USER_GROUP_SUCCESS: {
            const displayedUsersGroups = reject([...state.groups], ['GroupId', action.payload.id]);
            const newTotal = state.totalGroups - 1;

            return {
                ...state,
                groups: displayedUsersGroups,
                totalGroups: newTotal
            };
        }
        case DELETE_USER_GROUP_FAILURE: {
            const usersGroupsList = map([...state.groups], group => group.GroupId === action.payload.id
                ? { ...group, removing: false }
                : group
            );

            return {
                ...state,
                groups: usersGroupsList
            };
        }
        case SEARCH_MEMBERS_REQUEST: {
            return {
                ...state,
                memberSuggestions: state.suggestionSearchText !== action.payload.searchText ? [] : state.memberSuggestions,
                suggestionsError: false,
                suggestionSearchText: action.payload.searchText,
                isFetchingMemberSuggestions: true
            };
        }
        case SEARCH_MEMBERS_SUCCESS: {
            return {
                ...state,
                memberSuggestions: [...state.memberSuggestions, ...action.payload.members],
                suggestionsError: false,
                isFetchingMemberSuggestions: false
            };
        }
        case SEARCH_MEMBERS_FAILURE: {
            return {
                ...state,
                memberSuggestions: [],
                suggestionsError: true,
                isFetchingMemberSuggestions: false
            }
        }
        case SET_TOTAL_MEMBER_SUGGESTIONS: {
            return {
                ...state,
                totalMemberSuggestions: action.payload.total
            };
        }
        case ADD_MEMBER: {
            const duplicatedMember = find(state.members, ['UserId', action.payload.member.UserId]);
            const newMembers = duplicatedMember ? [...state.members] : [...state.members, action.payload.member];

            return {
                ...state,
                members: newMembers
            };
        }
        case DELETE_MEMBER: {
            const newMembers = reject([...state.members], ['UserId', action.payload.id]);

            return {
                ...state,
                members: newMembers
            };
        }
        case DELETE_ALL_MEMBERS: {
            return {
                ...state,
                members: []
            };
        }
        case GROUP_GENERAL_INFORMATION_READY: {
            return {
                ...state,
                groupGeneralInformationReady: action.payload.status,
                groupGeneralInformation: action.payload.data
            };
        }
        case GROUP_EXPRESS_CONFIGURATION_READY: {
            return {
                ...state,
                groupExpressConfigurationReady: action.payload.status,
                groupExpressConfiguration: action.payload.data
            };
        }
        case GROUP_USERS_CONFIGURATION_READY: {
            return {
                ...state,
                groupUsersConfigurationReady: action.payload.status,
                groupUsersConfiguration: action.payload.data
            };
        }
        case GET_MUSIC_ON_HOLD_REQUEST: {
            return {
                ...state,
                musicOnHold: {
                    ...state.musicOnHold,
                    fetching: true
                }
            };
        }
        case GET_MUSIC_ON_HOLD_SUCCESS: {
            return {
                ...state,
                musicOnHold: {
                    ...state.musicOnHold,
                    fetching: false,
                    moh: action.payload.MusicOnHold,
                    error: false
                },
                edition: {
                    ...state.edition,
                    error: false
                }
            };
        }
        case GET_MUSIC_ON_HOLD_FAILURE: {
            return {
                ...state,
                musicOnHold: {
                    ...state.musicOnHold,
                    fetching: false,
                    moh: [],
                    error: true
                },
                edition: {
                    ...state.edition,
                    error: true
                }
            };
        }
        case CREATE_USER_GROUP_REQUEST: {
            return {
                ...state,
                isCreating: true
            };
        }
        case CREATE_USER_GROUP_SUCCESS: {
            return {
                ...state,
                isCreating: false,
                error: false
            };
        }
        case CREATE_USER_GROUP_FAILURE: {
            return {
                ...state,
                isCreating: false,
                error: true
            };
        }
        case CLEAN_USER_GROUP: {
            return {
                ...state,
                edition: {
                    group: null,
                    isEditing: false,
                    error: false,
                    fetching: false
                },
                groupGeneralInformationReady: false,
                groupGeneralInformation: null,
                groupExpressConfigurationReady: false,
                groupExpressConfiguration: initialState.groupExpressConfiguration,
                groupUsersConfigurationReady: false,
                groupUsersConfiguration: null,
                memberSuggestions: [],
                members: []
            };
        }
        case GET_USER_GROUP_REQUEST: {
            return {
                ...state,
                edition: {
                    ...state.edition,
                    fetching: true
                }
            };
        }
        case GET_USER_GROUP_SUCCESS: {
            return {
                ...state,
                edition: {
                    ...state.edition,
                    fetching: false,
                    group: action.payload.userGroup,
                    error: false
                },
            };
        }
        case GET_USER_GROUP_FAILURE: {
            return {
                ...state,
                edition: {
                    ...state.edition,
                    fetching: false,
                    error: true
                }
            };
        }
        case SET_MEMBERS: {
            return {
                ...state,
                members: action.payload.members
            };
        }
        case UPDATE_USER_GROUP_REQUEST: {
            return {
                ...state,
                edition: {
                    ...state.edition,
                    isEditing: true
                }
            };
        }
        case UPDATE_USER_GROUP_SUCCESS: {
            return {
                ...state,
                edition: {
                    ...state.edition,
                    isEditing: false,
                    error: false
                }
            };
        }
        case UPDATE_USER_GROUP_FAILURE: {
            return {
                ...state,
                edition: {
                    ...state.edition,
                    isEditing: false,
                    error: true
                }
            };
        }
        case SEARCH_DEFAULT_EXTENSION_REQUEST: {
            return {
                ...state,
                defaultExtensionSuggestions: state.defaultExtensionSearchText !== action.payload.searchText
                    ? []
                    : state.defaultExtensionSuggestions,
                defaultExtensionSearchText: action.payload.searchText,
                isFetchingDefaultExtensionSuggestions: true
            };
        }
        case SEARCH_DEFAULT_EXTENSION_SUCCESS: {
            return {
                ...state,
                defaultExtensionSuggestions: [...state.defaultExtensionSuggestions, ...action.payload.members],
                suggestionsError: false,
                isFetchingDefaultExtensionSuggestions: false
            };
        }
        case SEARCH_DEFAULT_EXTENSION_FAILURE: {
            return {
                ...state,
                defaultExtensionSuggestions: [],
                isFetchingDefaultExtensionSuggestions: false
            }
        }
        case SET_TOTAL_DEFAULT_EXTENSION: {
            return {
                ...state,
                totalDefaultExtensionSuggestions: action.payload.total
            };
        }
        case SET_DEFAULT_EXTENSION: {
            return {
                ...state,
                groupExpressConfiguration: {
                    ...state.groupExpressConfiguration,
                    Extension: action.payload.defaultExtension
                }
            }
        }
        default: return state;
    }
};
